export { resetKeyboard // 键盘兼容性函数
};
/**
 * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug
 */
function resetKeyboard() {
  // 兼容部分ios手机键盘谈起不收回的情况  // 这里加了个类型判断，因为a等元素也会触发blur事件
  if (/iphone|ipod|ipad/i.test(navigator.userAgent)) {
    document.addEventListener('blur', function (e) {
      var _e$target;
      /* eslint-disable no-self-assign */
      ;
      ['input', 'textarea'].includes(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.localName) && document.body && (document.body.scrollTop = document.body.scrollTop);
    }, true);
  }
}